
<template>
  
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >
    
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag' //importação do gql para execução de queries do GraphQL
import BaseIndex from "@shared_components/base_index.vue"; //importação do baseIndex
import New from "./new.vue"; //importação do componente que vai representar o new do model
import Edit from "./edit.vue"; //importação do componente que vai representar o edit do model
import Delete from "./delete.vue"; //importação do componente que vai representar o delete do model

export default {
  data() {
    return {
      indexItems: [], //representa a lista de itens que serão exibidos no index
      loading: true, //indica se a tabela está carregando
      pageLoading: false, //indica se a tela está em carregando
      totalItems: 0, //indica o numero total de itens, utilizado para a paginação
      tableHeaders: [ //indica as colunas que serão exibidas na tabela e seus respectivos values que vem do banco. IMPORTANTE: o sortable indica se a coluna pode ser ordenada, mas isso vai ocorrer server-side
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Tipo", align: "left", sortable: true, value: "typeValue", filter_value: "type"},
        { text: "Patrimônio", align: "left", sortable: true, value: "patrimony.description" },
        { text: "Fornecedor", align: "left", sortable: true, value: "cashOutflow.supplier.name" },
        { text: "Data", align: "left", sortable: true, value: "date" },
        { text: "Horímetro", align: "left", sortable: true, value: "hourMeter" },
        { text: "Odômetro", align: "left", sortable: true, value: "odometer"}, 
        { text: "Cód. Conta a Pagar", align: "left", sortable: true, value: "cashOutflow.code"},
        { text: "Ações", align: "left", sortable: false, value: "action" } //coluna que representa as ações que o usuário pode realizar, deve sempre constar nas tabelas (o edit e delete são colocados aqui dentro)
      ],
      maskFields: [ //indica os campos que serão aplicados mascaras, como por exemplo data, valor númerico, valor monetário,... o campo field tem que ser igual o campo value da tableHeaders
        { field: 'date', mask: 'date' },
        // { field: 'type', mask: 'list', list: serviceProvisionTypeList },
        // { field: 'totalPrice', mask: 'currency'},
        // { field: 'totalPaidAmount', mask: 'currency' },
        // { field: 'unpaidAmount', mask: 'currency'},
      ],
      infoHeaders: [ //indica as colunas que terão o i de informação. o campo field tem que ser igual o campo value da tableHeaders
        // { field: 'totalPrice', info: 'Valor da conta a pagar (capital)' },
        // { field: 'totalPaidAmount', info: 'Valor já pago da conta incluindo juros, multas e descontos' },
        // { field: 'unpaidAmount', info: 'Valor restante a ser pago (capital)' },
      ],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Serviço"
    },
    modelNamePlural: {
      type: String,
      default: "Serviços"
    },
  },
  components: { //todos os componentes adicionais que forem importados precisam ser registrados aqui
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() { //função executada quando o esse componente é criado
    // this.loadServerEntries();
  },
  mounted() { //função executada quando o esse componente é montado

  },
  methods: {
    applyFilters: function(filtersList) { //função executada quando o usuário adicionar, editar ou remover um filtro 
      this.filters = filtersList;
      this.options.page = 1; //sempre carrega a primeira página da paginação quando há alterações de filtros
      this.loadServerEntries();
    },
    loadServerEntries: function() { //ao carregar o index, essa função vai executar a query e buscar os dados do servidor
      this.loading = true; //coloca a tabela em loading antes de chamar a query no servidor
      this.$apollo
        .query({
          query: LOAD_ALL_SERVICES_PROVISION, //esse exemplo mostra uma query que traz todos os cash_outflows, levando em consideração paginação, ordenação e filtros
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null), //.map(val => val.value),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("response", response);
          this.indexItems = response.data.accountContext.servicesProvisionIndex.servicesProvision; //seta os itens retornados do servidor para o array de itens que será exibido na tabela

          this.totalItems = response.data.accountContext.servicesProvisionIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.servicesProvisionIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.servicesProvisionIndex.serverFields; // seta os campos que podem ser filtrados
          // console.log("All indexItems", this.indexItems, this.totalItems); // exibe os itens e o número total de itens no console se for preciso
        })
        .catch(response => console.log(response)) //se der uma exceção ao executar a query, vai jogar isso pro console do navegador
        .finally(() => (this.loading = false)); //ao finalizar a conexão, tira a tabela do loading
    },
    entryUpdated: function(){ //função chamada toda vez que um registro for atualizado
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){ //função chamada toda vez que um registro for criado
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){ //função chamada toda vez que um registro for deletado
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    // exemplo de função que pode ser utilizada para a adição de classes por item que será exibido na tabela
    // nesse exemplo, o item é passado como parametro, assim podem ser acessados atributos do item, como nesse caso o unpaidAmount.
    // se o unpaidAmount for maior que 0 vai adicionar a classe pending_item, que seta a cor do texto do item para vermelho.
    // caso isso seja necessário, descomentar aas linhas internas da função
    itemClasses: function(item) { 
      // if (item.unpaidAmount > 0) {
      //   return "pending_item";
      // }
    },
    optionsChange: function(opts) { //função que é executada toda vez que o usuário alterar alguma opção da paginação, dai recarrega a tabela
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

//exemplo da query do GraphQL que é chamada ao executar o loadServerEntries
const LOAD_ALL_SERVICES_PROVISION = gql `
  query($input: IndexInputObject!) {
    accountContext {
      servicesProvisionIndex(input: $input) {
        servicesProvision {
          id
          code
          type
          typeValue
          date
          patrimony{
            description
          }
          hourMeter
          odometer
          cashOutflow {
            id
            code
            supplier {
              id
              name
            }
          }
          canBeDeleted
          undeletabilityReasons
        }
        count
        typeOperators
        serverFields
      }
    }
  }
`;

</script>

<style scoped>
</style>
